const triggerMobileMenu = document.querySelector(".trigger-mobile-menu"),
  mobileMenu = document.querySelector(".mobile-menu"),
  mobileCross = document.querySelector(".mobile-menu-cross"),
  header = document.querySelector("header.header"),
  headerWrapper = document.querySelector(".c-header-wrapper"),
  headerLinks = document.querySelectorAll(".mobile-menu-left a"),
  announcementBar = document.querySelector(".announcement-utility-bar");

const mainContent = document.querySelector("main#MainContent");

mobileCross?.addEventListener("click", () => {
  document.body.classList.toggle("overflow");
  triggerMobileMenu.classList.toggle("is-show-menu");
  mobileMenu.classList.toggle("is-show");

  if (
    !triggerMobileMenu.classList.contains("is-show-menu") &&
    document.body.classList.contains("template-index")
  ) {
    if (window.scrollY < 20) {
      headerWrapper.classList.remove("is-scroll");
    }
  } else {
    headerWrapper.classList.add("is-scroll");
  }
});

triggerMobileMenu.addEventListener("click", () => {
  document.body.classList.toggle("overflow");
  triggerMobileMenu.classList.toggle("is-show-menu");
  mobileMenu.classList.toggle("is-show");

  if (
    !triggerMobileMenu.classList.contains("is-show-menu") &&
    document.body.classList.contains("template-index")
  ) {
    if (window.scrollY < 20) {
      headerWrapper.classList.remove("is-scroll");
    }
  } else {
    headerWrapper.classList.add("is-scroll");
  }
  headerStylesHandler();
});

function headerStylesHandler() {
  const headerHeight = parseFloat(
    window.getComputedStyle(header).getPropertyValue("height"),
  );

  let announcementBarHeight = 0;

  if (announcementBar) {
    announcementBarHeight = announcementBar.offsetHeight;
  }

  let mobileMenuEl = mobileMenu.querySelector(".mobile-menu-wrapper");
  if (window.innerWidth <= 1250) {
    let headerAllHeight =
      window.scrollY >= announcementBarHeight
        ? headerHeight
        : headerHeight + (announcementBarHeight - scrollY);
    mobileMenu.style.position = "fixed";
    mobileMenu.style.top = `${headerAllHeight}px`;
    mobileMenuEl.style.marginTop = `12px`;
    mobileMenu.style.height = `calc(100vh - ${headerAllHeight}px)`;
  } else {
    mobileMenuEl.style.marginTop = `0px`;
    mobileMenu.style.position = "absolute";
    mobileMenu.style.top = `calc(100% + 12px)`;
    mobileMenu.style.height = `initial`;
  }
}

window.addEventListener("resize", headerStylesHandler);
window.addEventListener("load", headerStylesHandler);

function headerScrollHandler() {
  if (window.scrollY > 20) {
    headerWrapper.classList.add("is-scroll");
  } else {
    headerWrapper.classList.remove("is-scroll");
  }
}

function bodyPaddingHandler() {
  const header = document.querySelector("header.header");
  const headerHeight = parseFloat(
    window.getComputedStyle(header).getPropertyValue("height"),
  );

  mainContent.style.paddingTop = `${headerHeight}px`;
}

if (!document.body.classList.contains("template-index")) {
  headerWrapper.classList.add("is-scroll");
  window.addEventListener("load", bodyPaddingHandler);
  window.addEventListener("resize", bodyPaddingHandler);
} else {
  window.addEventListener("scroll", headerScrollHandler);
  window.addEventListener("load", headerScrollHandler);
}

headerLinks.forEach((link) => {
  if (window.location.pathname == link.getAttribute("href"))
    link.classList.add("active");
});
const localizationCode = localStorage.getItem("localization-code");
const localizationStringCart =
  localizationCode === "en" ? "/cart" : `/${localizationCode}/cart`;

document
  .querySelector(".button-cart-header")
  ?.addEventListener(
    "click",
    () => (window.location.href = localizationStringCart),
  );
